import { ESettingsStepFriendlyNames } from '~/features/settings/models'
import EHeyLibbyAdminNavItemNames from '~/layouts/account/constants/navItems'
import {
  EClientPath,
  EAdminPortalClientPath,
  EMarketingClientPath,
} from '~/models/api'

enum EAccountGridAreas {
  CONTENT = 'content',
  HEADER = 'header',
  NAV = 'nav',
}

export default EAccountGridAreas

export enum ENavSectionNames {
  assistantSetup = 'Assistant Setup',
  campaigns = 'Campaigns',
  conversations = 'Conversations',
  voip = 'VoIP',
}

export enum ENavItemNames {
  overview = 'Dashboard',
  businessInfo = 'Business Info',
  conversationSettings = 'Conversation Settings',
  liveTransfers = 'Live Transfers',
  channels = 'Channels',
  campaignManager = 'Campaign Manager',
  notifications = 'Notifications',
  apiKeys = 'API Keys',
  contacts = 'Contacts',
  analytics = 'Reports',
  postConvoSettings = 'Analysis Settings',
  settings = 'Assistant Settings',
  campaigns = 'Campaigns',
  reports = 'Reporting',
  billing = 'Billing',
  guidance = 'Setup guidance',
  referrals = 'Referrals program',
  help = 'Help',
  plan = 'Plan',
  support = 'Support',
  integrations = 'Integrations',
  termsOfUse = 'Terms of Use',
  privacyPolicy = 'Privacy Policy',
  referralsTerms = 'Referral Terms of Use',
  account = 'Account',
  inbox = 'Inbox',
  scenarios = 'Scenarios',
  actions = 'Actions',
  settingsCoreBehavior = 'Core Behavior',
  helpCenter = 'Help Center',
  apiReference = 'API Reference',
  termsAndPolicies = 'Terms & Policies',
  voipPhoneNumbers = 'Phone Numbers',
  voipDevices = 'Devices',
  voipCalls = 'Call History',
}

export enum EDocsPath {
  root = '', // to avoid match with marketing home
  zapierCrmIntegration = '/integrations/zapier-crm-integration',
  apiKeys = '/integrations/api-keys',
  bulkEdits = '/account-management/bulk-edits',
}

export type TNavItem = {
  name: string
  icon?: JSX.Element
  path?: EClientPath | EAdminPortalClientPath | EMarketingClientPath
  isOnBottom?: boolean
  children?: TNavItemChild[]
  secondaryText?: string
  isSectionHeader?: boolean
}

export type TNavItemChild = {
  name: ENavItemNames | ESettingsStepFriendlyNames | EHeyLibbyAdminNavItemNames
  path?: EClientPath | EMarketingClientPath | EAdminPortalClientPath | EDocsPath
  openInNewTab?: boolean
  children?: TNavItemChild[]
}
